import { markRaw, toRaw } from 'vue'
import type { Component } from 'vue'

/** Unwrap a component stored in reactive state so `:is` does not warn. */
export function resolveIcon(icon?: Component) {
  if (!icon || typeof icon === 'string') return icon
  return markRaw(toRaw(icon))
}
